/**
 * @file useAuth.js
 * @description Hook providing access to global authentication context.
 */

import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';

/**
 * Access active authentication context state and dispatch functions.
 *
 * @returns {Object} Context value including user, hospital, permissions, and auth methods.
 * @throws {Error} If called outside of an AuthProvider.
 */
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};